import { OptionType } from '@evinced-private/ui-common';

import { LABEL_PREFIXES, TestLabelsFilterOptions } from '../../types/filter-section-v2';

export const transformLabelsToV2Format = (labels: OptionType[]): TestLabelsFilterOptions => {
	const environmentFilters: OptionType[] = [];
	const unitIdFilters: OptionType[] = [];
	const customLabelFilters: OptionType[] = [];

	labels.forEach((label) => {
		const labelValue = String(label.value);
		if (labelValue.startsWith(LABEL_PREFIXES.ENVIRONMENT)) {
			// Extract just the value part (after "Environment: ")
			const value = labelValue.replace(new RegExp(`^${LABEL_PREFIXES.ENVIRONMENT}\\s*`, 'i'), '');
			environmentFilters.push({
				...label,
				label: value.charAt(0).toUpperCase() + value.slice(1)
			});
		} else if (labelValue.toLowerCase().startsWith(LABEL_PREFIXES.UNIT_ID)) {
			// Extract unitId only from custom_fields (where key is "unitid")
			// Extract just the value part (after "unitid: ")
			const value = labelValue.replace(new RegExp(`^${LABEL_PREFIXES.UNIT_ID}\\s*`, 'i'), '');
			unitIdFilters.push({
				...label,
				label: value.charAt(0).toUpperCase() + value.slice(1)
			});
		} else {
			// Include Flow labels and all other custom labels in customLabelFilters
			customLabelFilters.push(label);
		}
	});

	// Sort custom labels alphabetically
	const sortedCustomLabels = [...customLabelFilters].sort((a, b) => a.label.localeCompare(b.label));

	return {
		environmentFilters,
		unitIdFilters,
		customLabelFilters: sortedCustomLabels.slice(0, 3),
		allCustomLabelFilters: sortedCustomLabels
	};
};
